import { PreviewItemNotaFiscal, RegraNotaFiscal, RegraNotaFiscalForm } from '../../../types/notaFiscalApiTypes'
import { Acao, Condicao } from '../../../types/regraApiType'
import { PriorizacaoRegras } from '../../../types/transformacaoApiTypes'
import instance from '../../axiosInstance'

const buscarCondicoes = async (): Promise<Condicao[]> => {
  const URL_BUSCAR_CONDICOES = '/TransformacaoNotaFiscal/Regras/Operacoes/Condicoes'
  const response = await instance.conectarGet<Condicao[]>(URL_BUSCAR_CONDICOES)
  return response.data
}

const buscarAcoes = async (): Promise<Acao[]> => {
  const URL_BUSCAR_ACOES = '/TransformacaoNotaFiscal/Regras/Operacoes/Acoes'
  const response = await instance.conectarGet<Acao[]>(URL_BUSCAR_ACOES)
  return response.data
}

const cadastrarRegra = async (body: RegraNotaFiscalForm, parceiroId?: string | number): Promise<string> => {
  const URL_CADASTRAR_REGRA = `/TransformacaoNotaFiscal/Parceiros/${parceiroId}/Regras`
  const response = await instance.conectarPost<string>(URL_CADASTRAR_REGRA, body)
  return response.data
}

const editarRegra = async (body: RegraNotaFiscalForm, parceiroId?: string | number, regraId?: string | number): Promise<string> => {
  const URL_EDITAR_REGRA = `/TransformacaoNotaFiscal/Parceiros/${parceiroId}/Regras/${regraId}`
  const response = await instance.conectarPut<string>(URL_EDITAR_REGRA, body)
  return response.data
}

const buscarRegras = async (parceiroId?: string | number): Promise<RegraNotaFiscal[]> => {
  const URL_BUSCAR_REGRAS = `/TransformacaoNotaFiscal/Parceiros/${parceiroId}/Regras`
  const response = await instance.conectarGet<RegraNotaFiscal[]>(URL_BUSCAR_REGRAS)
  return response.data
}

const buscarRegra = async (parceiroId?: string | number, regraId?: string | number): Promise<RegraNotaFiscal> => {
  const URL_BUSCAR_REGRA = `/TransformacaoNotaFiscal/Parceiros/${parceiroId}/Regras/${regraId}`
  const response = await instance.conectarGet<RegraNotaFiscal>(URL_BUSCAR_REGRA)
  return response.data
}

const enviarArquivo = async (body: string[]): Promise<string> => {
  const URL_ENVIAR_ARQUIVO = `/Arquivo`
  const response = await instance.conectarPost<string>(URL_ENVIAR_ARQUIVO, body)
  return response.data
}

const previewRegra = async (body: RegraNotaFiscalForm, arquivoId?: string | number): Promise<PreviewItemNotaFiscal> => {
  const URL_BUSCAR_PREVIEW = `/TransformacaoNotaFiscal/Arquivos/${arquivoId}/Preview`
  const response = await instance.conectarPost<PreviewItemNotaFiscal>(URL_BUSCAR_PREVIEW, body)
  return response.data
}

const reordenarPrioridade = async (parceiroId: number | string, body: PriorizacaoRegras[]): Promise<boolean> => {
  const URL_REORDENAR_PRIORIDADE = `/TransformacaoNotaFiscal/Parceiros/${parceiroId}/RegrasPrioridade`
  const response = await instance.conectarPut<boolean>(URL_REORDENAR_PRIORIDADE, body)
  return response.data
}

export default {
  buscarCondicoes,
  buscarAcoes,
  cadastrarRegra,
  editarRegra,
  buscarRegras,
  enviarArquivo,
  previewRegra,
  reordenarPrioridade,
  buscarRegra
}
